import { useEffect, useState } from "react";
import { columnsheadId } from "../../universal/columnshead";
import MenuWarehouseUploadFileEdit from "./MenuWarehouseUploadFileEdit";
import systemExpand from "../../../config/systemExpand";
import UploadFileListUniversal, { UFLUExtendPropsType } from "../../system/UploadFileListUniversalNewEx";

//组件 MenuWarehouseUploadFile
export default function MenuWarehouseUploadFile(props: any) {

    //extendProps
    const [extendProps, setExtendProps] = useState<UFLUExtendPropsType>();

    //表头
    const columnsHead = [
        {
            title: '菜式名称',
            dataIndex: 'foodName',
            render: (text: any, record: any) => {
                return (
                    <div>{record.menuWarehouse.foodName}</div>
                )
            }
        },
    ];

    const filesColumns = columnsheadId
        .concat(columnsHead as []);

    useEffect(() => {
        systemExpand.getConfig({
            id: 'config',
            nodeId: 'files'
        }).then(res => {
            const { files } = res as any;
            const { menuWarehouseFilesGroupId } = files;
            setExtendProps({
                ...props,
                titleName: '菜品智库图片',
                apiId: 'menuWarehouse',
                filesGroupId: menuWarehouseFilesGroupId,
                fileType: "files",
                // fileType: "wiscaDisk",
                //+ File
                //上传 + UploadFile
                //删除 + DeleteFile
                filesColumns,
                showImage: true,
                showDownload: true,
                showStates: true,
                showDefault: true,
                extendIdName: "menuWarehouseId",
                EditComponent: MenuWarehouseUploadFileEdit,
                disableCheckBox: sessionStorage.getItem('isAdmin') === 'true' ? false : true
            })
        })
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    if (extendProps) {
        return (
            <UploadFileListUniversal props={extendProps} />
        )
    }
}